<div class="confirm-dialog flex flex-col">
  <div class="w-full text-end" *ngIf="data.dismissible">
    <svg-icon [svgStyle]="{'width.px':data.icon.size,'height,px':data.icon.size}" class="icon" name="cancel"
      [matDialogClose]="undefined"></svg-icon>
  </div>

  <!-- Content -->
  <div class="flex flex-col p-2 w-full">
    <div class="session_icon" *ngIf="data.icon.show && data.icon.options">
      <ng-lottie [options]="data.icon.options"  ></ng-lottie>
    </div>
    <!-- Icon -->
    <div class="flex flex-row">

    </div>
    <ng-container *ngIf="data.title || data.message">
      <div class="mt-4">
        <!-- Title -->
        <div class="" [ngClass]="{
          'name-basic': data.icon.color === 'basic',
          'name-info': data.icon.color === 'info',
          'name-success': data.icon.color === 'success',
          'name-warning': data.icon.color === 'warning',
          'name-error': data.icon.color === 'error'
          }">
          <ng-container *ngIf="data.title">
            <div class="text-xl text-center" [innerHTML]="data.title"></div>
          </ng-container>
        </div>

        <!-- Message -->
        <ng-container *ngIf="data.message">
          <div class="text-base text-center" [innerHTML]="data.message"></div>
        </ng-container>
      </div>
    </ng-container>

  </div>

  <!-- Actions -->
  <div class="mt-4  w-full" *ngIf="data.actions.confirm.show || data.actions.cancel.show">
    <div class="gap-2 sm:flex-col flex-row text-center">
      
      <!-- Cancel -->
      <button class="btn-action" mat-stroked-button [matDialogClose]="'cancelled'" *ngIf="data.actions.cancel.show">
        {{data.actions.cancel.label}}
      </button>

      <!-- Confirm -->
      <button class="btn-action" mat-flat-button [color]="data.actions.confirm.color" [matDialogClose]="'confirmed'"
        *ngIf="data.actions.confirm.show">
        {{data.actions.confirm.label}}
      </button>

    </div>
  </div>

</div>